/**
 * Environment-aware URL configuration.
 *
 * Detects the running environment by comparing window.location.origin
 * against the known base URLs for each environment.
 *
 * Environments:
 *   production  --> https://gadget.acrossassist.in/
 *   staging     --> https://gadgetuat.acrossassist.in/
 *   development --> http://localhost:3000  (or any unrecognised origin)
 */

const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://gadget360shield.acrossassist.com/",
    API_BASE_URL: "https://portal.acrossassist.com",
  },
  staging: {
    BASE_URL: "https://gadgetuat.acrossassist.in/",
    // API_BASE_URL: "https://gadgetuatapi.acrossassist.in",
    API_BASE_URL: "https://portal.acrossassist.com",
  },
  development: {
    BASE_URL: "http://localhost:3000",
    API_BASE_URL: "https://portal.acrossassist.com",
    // API_BASE_URL: "https://gadgetuatapi.acrossassist.in",
  },
};

/**
 * Detects current env from window.location.origin.
 * Falls back to 'development' for any unrecognised origin
 * (e.g. CRA dev server on :3001, jest jsdom, etc.)
 */
const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) return "production";
  if (baseUrl === ENVIRONMENTS.staging.BASE_URL) return "staging";
  if (baseUrl === ENVIRONMENTS.development.BASE_URL) return "development";
  return "development";
};

const CURRENT_ENV = getEnvironment();

/** Full config object: { BASE_URL, API_BASE_URL } */
export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};

/** Convenience named export — the API base URL string for axios / fetch */
export const API_BASE_URL = URL_CONFIG.API_BASE_URL;

export default URL_CONFIG;
